import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { FinancialYear } from '../../../../../shared/models/ExpressionOfInterest';



@Component({
  selector: 'app-eoi-view',
  templateUrl: './eoi-view.component.html',
  styleUrl: './eoi-view.component.css'
})


export class EoiViewComponent implements OnInit {
  formEOI!: FormGroup;
 

  displayedColumns: string[] = [
    'Fin_Year',
    'TurnoverFY2020_21',
    'TurnoverFY2021_22',
    'TurnoverFY2022_23',
    'TurnoverFY2023_24',
    'TurnoverFY2024_25'
  ];


  dataSource = new MatTableDataSource<FinancialYear>([]);


  //Extra variable declare 
  UserType: string | null = null;
  EnterpriseUniqueId: string | null = null;
  Action = false;
  constructor(private formBuilder: FormBuilder,
    private apiService: ApiService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private router: Router) {

    this.formEOI = this.formBuilder.group({
      //#region Enterprise Details
      EnterpriseCode: new FormControl({ value: '', disabled: true }),
      EnterpriseUniqueId: new FormControl({ value: '', disabled: true }),
      EnterpriseName: new FormControl({ value: '', disabled: true }),
      UdyamRegistrationNumber: new FormControl({ value: '', disabled: true }),
      EmailID: new FormControl({ value: '', disabled: true }),
      MobileNumber: new FormControl({ value: '', disabled: true }),
      DateOfEstablishment: new FormControl({ value: '', disabled: true }),
      PresentAddress: new FormControl({ value: '', disabled: true }),
      AreaOfCurrentSpace: new FormControl({ value: '', disabled: true }),
      RentAgreementPath: new FormControl({ value: '', disabled: true }),
      RentAgreementName: new FormControl({ value: '', disabled: true }),
      RentAgreementType: new FormControl({ value: '', disabled: true }),
      CurrentSpaceLocation: new FormControl({ value: '', disabled: true }),
      CurrentRentPaid: new FormControl({ value: '', disabled: true }),
      RentFrequency: new FormControl({ value: '', disabled: true }),
      NumberOfEmployees: new FormControl({ value: '', disabled: true }),
      UploadLastTwoRentPaymentReceiptsPath: new FormControl({ value: '', disabled: true }),
      UploadLastTwoRentPaymentReceiptsName: new FormControl({ value: '', disabled: true }),
      UploadLastTwoRentPaymentReceiptsType: new FormControl({ value: '', disabled: true }),
      SelfCertificationPath: new FormControl({ value: '', disabled: true }),
      SelfCertificationName: new FormControl({ value: '', disabled: true }),
      SelfCertificationType: new FormControl({ value: '', disabled: true }),
      District: new FormControl({ value: '', disabled: true }),
      Gender: new FormControl({ value: '', disabled: true }),
      EnterpriseType: new FormControl({ value: '', disabled: true }),
      SocialCategory: new FormControl({ value: '', disabled: true }),
      NoofEmployees: new FormControl({ value: '', disabled: true }),
      // #endregion

      //#region Product Details
      Sector: new FormControl({ value: '', disabled: true }),
      NICCode: new FormControl({ value: '', disabled: true }),
      PresentProductPath: new FormControl({ value: '', disabled: true }),
      PresentProductName: new FormControl({ value: '', disabled: true }),
      PresentProductType: new FormControl({ value: '', disabled: true }),
      // #endregion

      //#region Legal Information
      GSTRegistrationNumber: new FormControl({ value: '', disabled: true }),
      PanCardNumber: new FormControl({ value: '', disabled: true }),
      UdyamCertificatePath: new FormControl({ value: '', disabled: true }),
      UdyamCertificateName: new FormControl({ value: '', disabled: true }),
      UdyamCertificateType: new FormControl({ value: '', disabled: true }),
      PanCardNumberPath: new FormControl({ value: '', disabled: true }),
      PanCardNumberName: new FormControl({ value: '', disabled: true }),
      PanCardNumberType: new FormControl({ value: '', disabled: true }),
      GSTRegistrationCertificatePath: new FormControl({ value: '', disabled: true }),
      GSTRegistrationCertificateName: new FormControl({ value: '', disabled: true }),
      GSTRegistrationCertificateType: new FormControl({ value: '', disabled: true }),
      CPCBPath: new FormControl({ value: '', disabled: true }),
      CPCBName  : new FormControl({ value: '', disabled: true }),
      CPCBType: new FormControl({ value: '', disabled: true }),
      // #endregion
    });
  }

  ngOnInit(): void {
    // Retrieve the parameter value
    this.UserType = sessionStorage.getItem('UserType');
    this.route.params.subscribe(params => {
      this.EnterpriseUniqueId = params['enterpriseuniqueid'];
      if (params['action'] == 'view') {
        this.Action = true;
      }
      if (this.EnterpriseUniqueId) {
        this.LoadDetails(this.EnterpriseUniqueId);
      }
    });   
  }

  openFilePreviewDialog(filePath: string, fileName: string): void {
    debugger;
    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

  LoadDetails(EnterpriseUniqueId: string) {
    this.apiService.getRequest(API_ENDPOINTS.EOI.GETResEoi, { EnterpriseUniqueId }).subscribe(
      result => {
        //debugger;
        if (result.status && result.data.length > 0) {
          const record = result.data[0];
          console.table(record);

          // Patch form values
          this.formEOI.patchValue(record)

          // Assign table data from top-level turnover fields
          this.dataSource.data = [
            {
              Fin_Year: record.TurnoverFY2020_21,
              TurnoverFY2020_21: record.TurnoverFY2020_21,
              TurnoverFY2021_22: record.TurnoverFY2021_22,
              TurnoverFY2022_23: record.TurnoverFY2022_23,
              TurnoverFY2023_24: record.TurnoverFY2023_24,
              TurnoverFY2024_25: record.TurnoverFY2024_25,
              FY2020_21_Path: record.FY2020_21_Path,
              FY2020_21_Name: record.FY2020_21_Name,
              FY2020_21_Type: record.FY2020_21_Type,
              FY2021_22_Path: record.FY2021_22_Path,
              FY2021_22_Name: record.FY2021_22_Name,
              FY2021_22_Type: record.FY2021_22_Type,
              FY2022_23_Path: record.FY2022_23_Path,
              FY2022_23_Name: record.FY2022_23_Name,
              FY2022_23_Type: record.FY2022_23_Type,
              FY2023_24_Path: record.FY2023_24_Path,
              FY2023_24_Name: record.FY2023_24_Name,
              FY2023_24_Type: record.FY2023_24_Type,
              FY2024_25_Path: record.FY2024_25_Path,
              FY2024_25_Name: record.FY2024_25_Name,
              FY2024_25_Type: record.FY2024_25_Type,
            }
          ];
        } else {
          console.error('Failed to load user details:', result.message);
          this.dataSource.data = []; // empty table
        }
      },
      error => {
        console.error('API Error:', error);
        this.dataSource.data = []; // empty table
      }
    );
  }

  back() {
    this.UserType = sessionStorage.getItem('UserType');
    if (this.UserType == 'MSSIDC')
      this.router.navigate(['/eoi-list']);
  }


}




